import script from "./Contacto.vue?vue&type=script&lang=js"
export * from "./Contacto.vue?vue&type=script&lang=js"

import "./Contacto.vue?vue&type=style&index=0&id=4482a42d&lang=css"

const __exports__ = script;

export default __exports__